// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function usuarioTienePermiso(user: any, permiso: string): boolean {
  let result = false;
  switch (permiso) {
    case "*":
      result = true;
      break;
    case "superadmin":
      result = user.roleId === "SUPER_ADMIN";
      break;
    case "admin":
      result = user.roleId === "ADMIN";
      break;
    case "externo":
      result = user.roleId === "GESTION_EXT";
      break;
    default:
      result = true;
      break;
  }
  return result;
}
